import { Pipe, PipeTransform } from '@angular/core';
import {
  AttributeValidator,
  AttributeValidatorModel,
} from '@app/shared/interfaces/Attribute';

@Pipe({
  name: 'ValidatorName',
})
export class ValidatorNamePipe implements PipeTransform {
  transform(
    value: AttributeValidator,
    validatorsModels: AttributeValidatorModel[]
  ): any {
    const validator = validatorsModels.find(
      (x) => x.code == value.ValidatorType
    );
    return validator?.name;
  }
}
